import React, { forwardRef, type MouseEventHandler, type ReactNode } from 'react';
import { style } from 'typestyle';
import componentStyle from './center.styles';
import { CrossAxisAlignment, Flex, FlexDirection, MainAxisAlignment } from '../flex/flex.component';
import mergeClasses from '../../utils/merge-classes';

export enum CenterDirection {
  Horizontal,
  Vertical,
}

interface Props {
  readonly direction?: CenterDirection;
  readonly className?: string;
  readonly children: ReactNode;
  readonly onClick?: MouseEventHandler;
}

export const Center = forwardRef<HTMLDivElement, Props>(({ direction, className, children, onClick }, ref) => {
  const centerHorizontal = direction === undefined || direction === CenterDirection.Horizontal;
  const centerVertical = direction === undefined || direction === CenterDirection.Vertical;

  return (
    <Flex
      ref={ref}
      className={mergeClasses(className, centerVertical ? style(componentStyle) : undefined)}
      direction={FlexDirection.Row}
      mainAxisAlignment={centerHorizontal ? MainAxisAlignment.Center : undefined}
      crossAxisAlignment={centerVertical ? CrossAxisAlignment.Center : undefined}
      onClick={onClick}
    >
      {children}
    </Flex>
  );
});
